import { render, staticRenderFns } from "./PublicContent.vue?vue&type=template&id=71091aae&scoped=true&"
import script from "./publicContent.ts?vue&type=script&lang=ts&"
export * from "./publicContent.ts?vue&type=script&lang=ts&"
import style0 from "./PublicContent.vue?vue&type=style&index=0&id=71091aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71091aae",
  null
  
)

export default component.exports